import palette from '../../../theme/palette'

/* Labels and colour tokens for EDD Breach Attribution (docs/NABD_ATTRIBUTION_SPEC.md, PTL team answers 03-Oct-2026:
   External is its own owner; only "Not attributed" is red). Colours come from the palette only. */

export const TABS = [
  { key: 'U', label: 'Undelivered, past EDD', icon: 'pending' },
  { key: 'D', label: 'Delivered after EDD', icon: 'done' },
]

export const OWNERS = {
  NONE: { label: 'Not attributed', short: 'Not attributed', hint: 'No position taken yet', color: palette.error.dark, bg: palette.error.lighter, accent: 'error' },
  PROZO: { label: 'Prozo attributable', short: 'Prozo', hint: 'PTL Operations owns it', color: palette.primary.dark, bg: palette.primary.lighter, accent: 'primary', desc: 'Prozo, our WH or our carrier' },
  CLIENT: { label: 'Client attributable', short: 'Client', hint: 'The KAM owns it', color: palette.warning.darker, bg: palette.warning.lighter, accent: 'warning', desc: 'Client or consignee side' },
  EXTERNAL: { label: 'Non-controllable / External', short: 'External', hint: 'PTL Operations owns it', color: palette.chart.violet[0], bg: palette.grey[200], accent: 'secondary', desc: 'Force majeure: rain, strike, yatra, curfew…' },
}
export const OWNER_KEYS = ['NONE', 'PROZO', 'CLIENT', 'EXTERNAL']
export const ATTRIBUTABLE = ['PROZO', 'CLIENT', 'EXTERNAL']

export const PENDING_WITH = [
  { value: 'CLIENT', label: 'Client' },
  { value: 'KAM', label: 'KAM' },
  { value: 'PTL_OPS', label: 'PTL Ops' },
  { value: 'CARRIER', label: 'Carrier' },
]

export const BUCKETS = ['0-2d', '3-5d', '6-10d', '10d+']
export const BUCKET_LABEL = { '0-2d': '0 to 2 days', '3-5d': '3 to 5 days', '6-10d': '6 to 10 days', '10d+': 'Over 10 days', All: 'All' }

/* Owner → team it routes to (spec §4). */
export const TEAM_OF = { PROZO: 'PTL_OPS', CLIENT: 'KAM', EXTERNAL: 'PTL_OPS' }
export const TEAM_LABEL = { PTL_OPS: 'PTL Operations', KAM: 'Key Account Manager' }
export const TEAM_SHORT_LABEL = { PTL_OPS: 'PTL Ops', KAM: 'KAM' }
/* Teams a member can be on (Team Master checkboxes); a member may be on several. */
export const TEAM_OPTIONS = [
  { value: 'PTL_OPS', hint: 'takes Prozo attributable and External delays' },
  { value: 'KAM', hint: 'takes Client attributable delays' },
]
/* Can this team member act for a team? A member can act for every team in `roles` (same rule as the backend). */
export const canAct = (m, team) => !!m && (m.roles || []).includes(team)
/* "PTL Operations + Key Account Manager"; pass TEAM_SHORT_LABEL for "PTL Ops + KAM". */
export const rolesLabel = (m, labels = TEAM_LABEL) => (m?.roles || []).map((r) => labels[r] || r).join(' + ')
export const SUB_TEAM_LABEL = { CORE_OPS: 'Core Operations', FTR: 'First Time Right' }

/* Default pending-with for an owner (spec §9.3); no root cause since the 06-Oct-2026 artifact, Ops can still pick Carrier. */
export const defaultPendingWith = (owner) => (owner === 'CLIENT' ? 'CLIENT' : 'PTL_OPS')

export const EMPTY_FILTERS = { merchant: '', courier: '', owner: '', pendingWith: '', memberId: '', bucket: '', q: '' }

/* Access module for the PTL Team Master (route, menu, PATH_ACCESS_MAP). */
export const PTL_EDD_ADMIN_ACCESS = 'PTL_EDD_ADMIN'
